<script lang="ts">
  import { browser } from '$app/env';
  import StylableSelect from '$lib/components/StylableSelect.svelte';
  import PageTitle from '$lib/teach/resources/PageTitle.svelte';

  import SolfegeSally from 'exercises/src/uTheory.Interaction/SolfegeSally/solfege-sally.svelte';
  import type { SolfegeSystemName } from 'shared/definitions/musicTheory/solfegeAndScaleDegrees';
  import { solfegeSystemNames } from 'shared/definitions/musicTheory/solfegeAndScaleDegrees';

  const modeNames = [
    'Major',
    'Natural Minor',
    'Harmonic Minor',
    'Natural and Harmonic Minor',
    'Natural and Melodic Minor',
  ] as const;
  let modeName: typeof modeNames[number] = 'Major';

  let system: SolfegeSystemName = 'solfegeDoMinor';
</script>

<PageTitle
  title="Solfege Sally"
  description={`
  A solfege memory game, loosely modeled after the popular electronic
  toy Simon. Play back the tune you hear in solfege. Each time you get
  it right, one more note is added!
`}
  seoImageUrl="/assets/solfege-sally/solfege-sally-seo.png"
  seoImageAlt="The Solfege Sally game: A black circle with the words Solfege Sally in the middle, surrounded by colorful buttons labeled Do Re Mi Fa Sol La Ti Do."
  seoImageHeight={3000}
  seoImageWidth={3000}
/>

<p class="text-gray text-lg leading-7 py-4">
  A solfege memory game, loosely modeled after the popular electronic toy Simon. Play back the tune
  you hear in solfege. Each time you get it right, one more note is added!
</p>

<StylableSelect options={modeNames.map((n) => ({ title: n, value: n }))} bind:value={modeName}
  >Mode:</StylableSelect
>
<StylableSelect
  options={solfegeSystemNames.map((n) => ({ title: n, value: n }))}
  bind:value={system}>Solfege System:</StylableSelect
>

{#if browser}
  <div>
    {#key `${modeName}${system}`}
      <SolfegeSally {modeName} {system} />
    {/key}
  </div>
{/if}
